export const ReportReviewReasons = {
  VIOLATION: 'VIOLATION',
  DUPLICATE: 'DUPLICATE',
  BAD_AUTHOR: 'BAD_AUTHOR',
  OFFENSIVE: 'OFFENSIVE',
  OTHER: 'OTHER'
};
export const ReportReplyReasons = {
  VIOLATION: 'VIOLATION',
  OFFENSIVE: 'OFFENSIVE',
  BAD_AUTHOR: 'BAD_AUTHOR',
  OTHER: 'OTHER'
};
export const Reportables = {
  REVIEW: 'REVIEW',
  REPLY: 'REPLY'
};
export const ReportReasons = {
  [Reportables.REVIEW]: ReportReviewReasons,
  [Reportables.REPLY]: ReportReplyReasons
};